<template>
    <div id="alert" >

        <div v-for="(alert, index) in stack" :key="index" >
            <b-alert
            :show="alert.show"   
            :variant="alert.variant"
            @dismissed="clearNotification(alert.id)"
            dismissible>{{alert.message}}</b-alert>
        </div>

    </div>

</template>
<script lang="ts">
import { defineComponent } from 'vue'
import store from "@/store"

export default defineComponent({
    data() {
      return {
      }
    },
    methods:{
        clearNotification(id:number){
            store.dispatch("removeNotificationById", id)
        }
    },
    computed: {
        stack(){
            return store.getters.notificationStack
        } 
    }
})

</script>
<style lang="scss">
    #alert{
        position: fixed;
        bottom: 10px;
        right: 5px;
        z-index: 10;
    }
</style>